import { render, staticRenderFns } from "./deleteClient.vue?vue&type=template&id=6ec43b89&scoped=true"
import script from "./deleteClient.vue?vue&type=script&lang=js"
export * from "./deleteClient.vue?vue&type=script&lang=js"
import style0 from "./deleteClient.vue?vue&type=style&index=0&id=6ec43b89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec43b89",
  null
  
)

export default component.exports